/**
 * Created by dv on 7/11/2017.
 */
import {
  DeleteZmCollectionAssetsMessage,
  DeleteZmCollectionAssetsQuery,
  FuidRrnInfo
} from "../../../autogenerated/ZoomBridge";

export default class DeleteZmCollectionAssets {
  /**
   *
   * @param collectionId{number} collection id for which the assets need to be deleted.
   * @param fuidList{FuidRrnInfo} collection of fuid for assets to be deleted
   */
  constructor(collectionId, fuidList) {
    this.fuidList = fuidList;
    this._collectionId = collectionId;
  }


  set logMsg(msg) {
    this._logMsg = msg;
    return this;
  }

  /**
   * Returns a {Promise} Instance with onSuccess and OnFailure method.
   * onSuccess method takes resp{SimpleResponse} type.
   * @return {Promise}
   * @public
   */
  run() {
    const query = new DeleteZmCollectionAssetsQuery();
    const msg = new DeleteZmCollectionAssetsMessage();
    msg.setCollectionId(this._collectionId);
    msg.setFuidRrnList(this.fuidList);
    //msg.setLogMsg(this._logMsg);
    query.message = msg;
    return query.run();
  }
}
